import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import { formatTimespent, formatName } from "../../../../services/report.service";

import styles from "../../reports.module.scss";
import entityStyles from "./styles.module.scss";

import DefaultAssetIcon from '../../../../images/defaultAsset.jpg';
import { Col, Row } from 'react-bootstrap';
import { localizedStrings } from "../../../../../localization/index"
import Truncate from 'src/components/truncate';

class CampaignListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <div className={cx(styles.item, entityStyles.contact, this.props.className)}>
        <div className={cx(styles.icon, entityStyles.icon, entityStyles.circleIconContainer)}>{this.props.index + 1}</div>
        <div>
          <h5 className={styles.title}><Truncate width={300}>{_.get(this.props.item, 'name')}</Truncate></h5>
          <ul className={styles.metrics}>
            <li>{_.get(this.props.item, 'analytics.views')} {this.localizedTabsCommons.views}</li>
            <li>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))} {this.localizedTabsCommons.avg_time}</li>
            <li>{_.get(this.props.item, 'analytics.assets')} {this.localizedTabsCommons.assets}</li>
          </ul>
        </div>
      </div>
    );
  }
}

class CampaignGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    return (
      <Row className={styles.row}>
        <Col className={styles.column} md={6}>
          <div className={cx(styles.item, entityStyles.contact, this.props.className)}>
            <div className={cx(styles.icon, entityStyles.icon)}>{this.props.index + 1}</div>
            <div>
              <h5 className={styles.title}>{_.get(this.props.item, 'name')}</h5>
            </div>
          </div>
        </Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.views')}</Col>
        <Col className={styles.column} md={2}>{formatTimespent(_.get(this.props.item, 'analytics.avgTimeSpent', 0))}</Col>
        <Col className={styles.column} md={2}>{_.get(this.props.item, 'analytics.assets')}</Col>
      </Row>
    );
  }
}

const Campaign = {
  List: CampaignListItem,
  Grid: CampaignGridItem,
};

export default Campaign;